/**
 *
 */
export const state = () => ({
    winter: [
        {
            name: 'lifts',
            isEnabled: true,
            labelKey: 'filter.lifts',
            class: '',
            children: [],
        },
        {
            name: 'pistes',
            isEnabled: true,
            labelKey: 'filter.pistes',
            class: '',
            children: [
                {
                    name: 'pistes-easy',
                    isEnabled: true,
                    labelKey: 'filter.easy',
                    class: 'item-blue',
                    children: [],
                },
                {
                    name: 'pistes-medium',
                    isEnabled: true,
                    labelKey: 'filter.medium',
                    class: 'item-red',
                    children: [],
                },
                {
                    name: 'pistes-hard',
                    isEnabled: true,
                    labelKey: 'filter.hard',
                    class: 'item-black',
                    children: [],
                },
                {
                    name: 'pistes-variant',
                    isEnabled: true,
                    labelKey: 'filter.variant',
                    class: 'item-variant',
                    children: [],
                },
            ],
        },
        // {
        //     name: 'adventure',
        //     isEnabled: true,
        //     labelKey: 'filter.adventure',
        //     class: '',
        //     children: [],
        // },
        // {
        //     name: 'skischool',
        //     isEnabled: true,
        //     labelKey: 'filter.skischool',
        //     class: '',
        //     children: [],
        // },
        {
            name: 'restaurants',
            isEnabled: true,
            labelKey: 'filter.restaurants',
            class: '',
            children: [],
        },
        {
            name: 'pois',
            isEnabled: true,
            labelKey: 'filter.pois',
            class: '',
            children: [],
        },
        {
            name: 'webcams',
            isEnabled: true,
            labelKey: 'filter.webcams',
            class: '',
            children: [],
        },
    ],

    summer: [
        {
            name: 'lifts',
            isEnabled: true,
            labelKey: 'filter.lifts',
            class: '',
            children: [],
        },
        {
            name: 'hiking',
            isEnabled: true,
            labelKey: 'filter.hiking',
            class: '',
            children: [],
        },
        {
            name: 'adventure',
            isEnabled: true,
            labelKey: 'filter.adventure',
            class: '',
            children: [],
        },
        {
            name: 'restaurants',
            isEnabled: true,
            labelKey: 'filter.restaurants',
            class: '',
            children: [],
        },
        {
            name: 'webcams',
            isEnabled: true,
            labelKey: 'filter.webcams',
            class: '',
            children: [],
        },
    ],

});

export const mutations = {



    resetFilter(state) {
        [...state.winter, ...state.summer].forEach((item) => {
            item.isEnabled = true;
            item.children.forEach((child) => {
                child.isEnabled = true;
            });
        });

    },

    setIsItemEnabled(state, { item, isEnabled }) {
        item.isEnabled = isEnabled;
    },
};

export const actions = {
    toggleItem({ commit, getters, rootState }, { item, parent }) {
        commit('setIsItemEnabled', {
            item,
            isEnabled: !item.isEnabled,
        });

        item.children.forEach((child) => {
            commit('setIsItemEnabled', {
                item: child,
                isEnabled: item.isEnabled,
            });
        });

        if (parent) {
            commit('setIsItemEnabled', {
                item: parent,
                isEnabled: parent.children.some((child) => child.isEnabled),
            });
        }
    },
};

export const getters = {
    items(state, otherGetters, rootState) {
        return state[rootState.currentSeason];
    },
};
